import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import connectUser from '../connectUser';
import SearchBar from '../ui/SearchBar';
import AppTile from '../ui/AppTile';
import { browseApps, searchApps, accessState, populatedCategories } from '../registry/selectors';
import './screens.css';

function StoreScreen({ userInfo }) {
  const history = useHistory();
  const routes = userInfo?.routes ? [...userInfo.routes] : [];
  const [query, setQuery] = useState('');
  const [cat, setCat] = useState('all');
  const cats = populatedCategories(routes);

  const results = query.trim()
    ? searchApps(query, routes)
    : browseApps(routes).filter((a) => cat === 'all' || a.category === cat);

  return (
    <div className="hive-container hive-screen">
      <div className="hive-store-search">
        <SearchBar value={query} onChange={setQuery} placeholder="Search apps, tools or solutions…" autoFocus />
      </div>

      {!query.trim() && (
        <div className="hive-filter-rail hive-scroll">
          <FilterChip label="All" active={cat === 'all'} onClick={() => setCat('all')} />
          {cats.map((c) => (
            <FilterChip key={c.id} label={c.label} active={cat === c.id} onClick={() => setCat(c.id)} />
          ))}
        </div>
      )}

      <h2 className="hive-section-title hive-store-heading">
        {query.trim() ? `Results for “${query.trim()}”` : cat === 'all' ? 'All apps' : cats.find((c) => c.id === cat)?.label}
      </h2>

      {results.length === 0 ? (
        <div className="hive-empty">
          <p>No apps match your search yet.</p>
        </div>
      ) : (
        <div className="hive-tile-grid">
          {results.map((app) => (
            <AppTile
              key={app.id}
              app={app}
              state={accessState(app, routes)}
              onClick={() => history.push(`/apps/${app.id}`)}
            />
          ))}
        </div>
      )}
    </div>
  );
}

function FilterChip({ label, active, onClick }) {
  return (
    <button type="button" className={`hive-filter-chip hive-tap${active ? ' is-active' : ''}`} onClick={onClick}>
      {label}
    </button>
  );
}

export default connectUser(StoreScreen);
